import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'od-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss'],
  standalone: false,
})
export class ChipComponent {
  @Input() showCross = false;
  @Input() selected = false;
  @Output() crossClicked = new EventEmitter();

  public cross() {
    this.crossClicked.emit();
  }
}
